import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/v5`;

export const v5Service = {
  getReference: async () => {
    const response = await axios.get(`${API_BASE}/reference`);
    return response.data;
  },

  getCircularitySummary: async () => {
    const response = await axios.get(`${API_BASE}/circularity/summary`);
    return response.data;
  },

  getCircularityStatements: async (organizationId = null) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    const response = await axios.get(`${API_BASE}/circularity/statements`, { params });
    return response.data;
  },

  getCircularityFlows: async (organizationId = null) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    const response = await axios.get(`${API_BASE}/circularity/flows`, { params });
    return response.data;
  },

  getEndOfLifeFlows: async (organizationId = null) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    const response = await axios.get(`${API_BASE}/circularity/end-of-life`, { params });
    return response.data;
  },

  getCircularityByFacility: async (organizationId = null) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    const response = await axios.get(`${API_BASE}/circularity/facilities`, { params });
    return response.data;
  },

  getLedgers: async () => {
    const response = await axios.get(`${API_BASE}/ledgers`);
    return response.data;
  },

  getWaterSummary: async () => {
    const response = await axios.get(`${API_BASE}/water/summary`);
    return response.data;
  },

  getWaterTransactions: async (organizationId = null, limit = 500) => {
    const params = { limit };
    if (organizationId) params.organization_id = organizationId;
    const response = await axios.get(`${API_BASE}/water/transactions`, { params });
    return response.data;
  },

  getWaterByFacility: async (organizationId = null) => {
    const params = organizationId ? { organization_id: organizationId } : {};
    const response = await axios.get(`${API_BASE}/water/facilities`, { params });
    return response.data;
  },

  getConservationChecks: async () => {
    const response = await axios.get(`${API_BASE}/conservation-checks`);
    return response.data;
  },
};
